module.exports = __webpack_public_path__ + "img/2000.3b34ec82.png";